// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Pager } from '../../../lib/pager';

const RootContainer = styled('div')<{ usePadding: boolean }>(({ theme, usePadding }) => ({
  ...(usePadding && {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  }),
  borderTop: `1px solid ${theme.palette.divider}`,
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
}));

interface Props {
  readonly page: number;
  readonly pageSize: number;
  readonly onUpdatePage: (page: number) => void;
  readonly onUpdatePageSize?: (pageSize: number) => void;
  readonly currentPageSize: number | null | undefined;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  readonly isLoading?: boolean;
  readonly error?: string | null | undefined;
  readonly disablePadding?: boolean;
}

export default function RightPager({
  page,
  pageSize,
  currentPageSize,
  hasPreviousPage,
  hasNextPage,
  onUpdatePage,
  onUpdatePageSize,
  isLoading,
  error,
  disablePadding,
}: Props): React.ReactElement {
  return (
    <RootContainer usePadding={!disablePadding}>
      <Pager
        page={page}
        pageSize={pageSize}
        currentPageSize={currentPageSize}
        hasPreviousPage={hasPreviousPage}
        hasNextPage={hasNextPage}
        onUpdatePage={onUpdatePage}
        onUpdatePageSize={onUpdatePageSize}
        isLoading={isLoading}
        error={error}
      />
    </RootContainer>
  );
}
